/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable indent */
// import { Dropdown } from 'bootstrap';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { EpButton } from '../EpButton';

import {
  EpDropdownProps,
  IEpDropdownDefaultListItems,
} from '../../interfaces/interfaces/components';
import './EpDropdown.scss';

export const EpDropdown: React.FC<EpDropdownProps> = ({
  dropdownId,
  dropdownDefaultListItems = [],
  dropdownMenuPlacement = 'left',
  customClasses = '',
  dropdownHasCaret = false,
  customTopElementsDropdownMenu,
  dropdownTriggerElement,
  customBottomElementsDropdownMenu,
  dropdownEvent = 'click',
}) => {
  const [showDrodownList, setShowDropdownList] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const triggerRef = useRef<HTMLAnchorElement>(null);

  const onToggleDropdownList = () => {
    setShowDropdownList((prev) => !prev);
  };

  const onAddDocumentListener = useCallback(() => {
    document.addEventListener('click', (event) => {
      const targetIsPartOfDropdown = dropdownRef?.current?.contains(
        event.target as Node,
      );

      if (targetIsPartOfDropdown) return;

      setShowDropdownList(false);
    });
  },[]);

  const onRemoveDocumentListener = useCallback(() => {
    document.removeEventListener('click', (event) => {
      setShowDropdownList(false);
    });
  },[]);

  useEffect(() => {
    if (showDrodownList) {
     onAddDocumentListener();
    } else {
      onRemoveDocumentListener();
    }

    return () => onRemoveDocumentListener();
  }, [showDrodownList]);


  console.log('30/12 - 11:30');

  return (
    <div
      className={`ep-dropdown ${customClasses}`}
      id={dropdownId}
      ref={dropdownRef}
      onClick={onToggleDropdownList}
    >
      <a
        ref={triggerRef}
        className={`ep-dropdown__trigger-element ${
          dropdownHasCaret ? '' : 'ep-dropdown__trigger-element-caret-hidden'
        }`}
        role="button"
      >
        {dropdownTriggerElement}
      </a>

      {showDrodownList && (
        <ul
          className={`ep-dropdown__menu ${dropdownMenuPlacement === 'left' ? 'ep-dropdown__menu--left' : 'ep-dropdown__menu--right'}`}
        >
          <li>{customTopElementsDropdownMenu}</li>

          {dropdownDefaultListItems?.map(
            (item: IEpDropdownDefaultListItems) => (
              <li className={`ep-dropdown__menu-item`} key={item.buttonId}>
                {item.buttonDropdownMenuListData &&
                item.buttonDropdownMenuListData.length > 0 ? (
                  <EpDropdown
                    dropdownId={`${dropdownId}-sub-${item.buttonId}`}
                    dropdownMenuPlacement={dropdownMenuPlacement}
                    dropdownEvent={dropdownEvent}
                    dropdownDefaultListItems={item.buttonDropdownMenuListData}
                    dropdownTriggerElement={
                      <EpButton
                        buttonId={item.buttonId}
                        buttonType="link-secondary"
                        buttonSize="sm"
                        buttonText={item.buttonText}
                        buttonLeftIconName={item.buttonLeftIconName}
                        buttonRightIconName="SolidCaretRight"
                        buttonOnClickFunc={item.buttonOnClickFunc}
                        buttonIsActive={item.buttonIsActive}
                        buttonIsDisabled={item.buttonIsDisabled}
                      />
                    }
                    customClasses="ep-dropdown--nested"
                  />
                ) : (
                  <EpButton
                    buttonId={item.buttonId}
                    buttonType="link-secondary"
                    buttonSize="sm"
                    buttonText={item.buttonText}
                    buttonDataBsTarget={item.buttonDataBsTarget}
                    buttonDataBsToggle={item.buttonDataBsToggle}
                    buttonLeftIconName={item.buttonLeftIconName}
                    buttonOnClickFunc={item.buttonOnClickFunc}
                    buttonLinkHref={item.buttonLinkHref}
                    buttonLinkTarget={item.buttonLinkTarget}
                    buttonIsActive={item.buttonIsActive}
                    buttonIsDisabled={item.buttonIsDisabled}
                  />
                )}
              </li>
            ),
          )}

          <li>{customBottomElementsDropdownMenu}</li>
        </ul>
      )}
    </div>
  );
};
